/** Bucket Storage privé des documents partagés (migration 0261). */
export const DOCUMENT_BUCKET = 'documents';

/** 20 Mo — miroir de `documents.size_bytes` et du `file_size_limit` du bucket (0261). */
export const MAX_DOCUMENT_BYTES = 20 * 1024 * 1024;

/**
 * Liste FERMÉE des types acceptés — miroir de `allowed_mime_types` du bucket
 * (migration 0261 ; garanti par `constants.test.ts`, qui relit le SQL).
 * Ni SVG ni HTML : un script exécutable sur le domaine de stockage.
 */
export const ALLOWED_DOCUMENT_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.spreadsheet',
  'text/plain',
  'text/csv',
] as const;

/** Extension → type, pour les navigateurs qui ne renseignent pas `file.type`. */
export const MIME_BY_EXTENSION: Record<string, (typeof ALLOWED_DOCUMENT_MIME_TYPES)[number]> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  gif: 'image/gif',
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  odt: 'application/vnd.oasis.opendocument.text',
  ods: 'application/vnd.oasis.opendocument.spreadsheet',
  txt: 'text/plain',
  csv: 'text/csv',
};

/** Valeur de l'attribut `accept` d'un `<input type="file">`. */
export const DOCUMENT_ACCEPT = [
  ...ALLOWED_DOCUMENT_MIME_TYPES,
  ...Object.keys(MIME_BY_EXTENSION).map((ext) => `.${ext}`),
].join(',');
